import { path } from 'ramda';

import { ENTITIES_STORE_KEY } from '@/redux/constants';

import { ENTITY_NAME } from './consts';

export const getDaoRoot = path([ENTITIES_STORE_KEY, ENTITY_NAME, 'dao']);
